function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M144.1,1.3c19.5,0,35.5,16,35.5,35.5s-16,35.5-35.5,35.5s-35.5-16-35.5-35.5C108.3,17.3,124.2,1.3,144.1,1.3 M35.8,173.2 c-19.5,0-35.5,16-35.5,35.5s16,35.5,35.5,35.5s35.5-16,35.5-35.5S55.3,173.2,35.8,173.2 M236.8,202.3l-30.2,16l30.9,14.2l5.7,33.4 l23.1-24.9l33.7,5l-16.7-29.8l14.9-30.5l-33.4,6.7l-24.5-23.8L236.8,202.3z M96.2,66.3C90.9,57.8,88,47.8,88,37.2c0-0.4,0-1.1,0-1.4 C42.2,58.1,10.6,105,10.3,159.3c7.8-3.9,16.3-6.4,25.6-6.4c1.8,0,3.6,0,5.7,0.4C43.6,115.6,65.3,83.7,96.2,66.3z M283.7,130.9 c-9.6-45.1-41.5-82.4-83.4-99.4c0,1.8,0.4,3.6,0.4,5.3c0,9.2-2.1,18.1-6.4,25.9c28.8,13.5,50.4,39.1,58.2,70.3l-13.5,1.1l16.7,17.8 l16.7,17.8l13.8-20.2l13.8-20.2L283.7,130.9z M216.6,242.8c-18.5,15.3-42.3,24.5-68.2,24.5c-25.6,0-49.4-9.2-67.8-24.1 c-6.4,8.5-15.3,14.9-25.6,18.8c24.5,22.7,57.5,36.6,93.4,36.6c27.7,0,53.6-8.2,75.3-22.4L216.6,242.8z"
});

function SvgIconProcess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProcess);
export default __webpack_public_path__ + "static/media/Icon_Process.a8892cbc.svg";
export { ForwardRef as ReactComponent };